<template>
  <div class="align-center h-full w-full flex-row justify-center">
    <PhSparkle size="128" color="#dddddd" />
  </div>
</template>

<script lang="ts" setup>
import { PhSparkle } from '@phosphor-icons/vue'
</script>
